import { InjectionToken } from '@angular/core';

export const FEATURE_NAME = '@zerops/zui/recipes';

export const API_URL = new InjectionToken<string>('zui-recipes/api-url');
